export const NAME = 'roles';
export const LEVEL_ONE = 'RolesComponentReducer';
